import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconButtonComponent } from './icon-button.component';
import { IconComponentModule } from '../icon/icon-component.module';

@NgModule({
    imports: [
        CommonModule,
        IconComponentModule
    ],
    declarations: [
        IconButtonComponent
    ],
    exports: [
        IconButtonComponent
    ]
})
export class IconButtonComponentModule {

}
